export const TYPES = {
  SET_DEFAULT_CLIENT_ALL: "default_client/SET_DEFAULT_CLIENT_ALL",
  SET_DEFAULT_CLIENT_OPEN_ADD: "default_client/SET_DEFAULT_CLIENT_OPEN_ADD",
  SET_DEFAULT_CLIENT_OPEN_EDIT: "default_client/SET_DEFAULT_CLIENT_OPEN_EDIT",
  SET_DEFAULT_CLIENT_SELECTED: "default_client/SET_DEFAULT_CLIENT_SELECTED",
  SET_DEFAULT_CLIENT_SEARCH: "default_client/SET_DEFAULT_CLIENT_SEARCH",
  SET_DEFAULT_CLIENT_INFO: "default_client/SET_DEFAULT_CLIENT_INFO",
  SET_DEFAULT_CLIENT_TYPE: "default_client/SET_DEFAULT_CLIENT_TYPE",
  //
  SET_DEFAULT_CLIENT_DETAIL: "default_client/SET_DEFAULT_CLIENT_DETAIL",
  //kyc
  SET_DEFAULT_CLIENT_STEP: "default_client/SET_DEFAULT_CLIENT_STEP",
};
